import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('hidden.bs.modal', this.reloadPage)
  }

  disconnect() {
    this.element.removeEventListener('hidden.bs.modal', this.reloadPage)
  }

  reloadPage() {
    window.location.reload()
  }
}
